import Cookies from 'js-cookie'
const TokenKey = 'accessToken'
const USERID = 'userId'

export function getToken() {
    return Cookies.get(TokenKey)
  }
  

  export function getUserId(){
    return Cookies.get(USERID)
  }

  export function setToken(token) {
    return Cookies.set(TokenKey, token)
  }
  
  export function setUserId(userId) {
    return Cookies.set(USERID, userId)
  }
  
  export function removeToken() {
    return Cookies.remove(TokenKey)
  }
  
  export function removeUserId(){
    return Cookies.remove(USERID)
  }